import styles from "./Load.module.css";

function Load() {
  return (
    <div className={styles.Load}>
      <h1>Loading...</h1>
    </div>
  );
}

export default Load;
